import React from "react";
import { Reveal } from "@/components/Reveal";

export const CLIENT_LOGOS = [
  { name: "IBM",              src: "/assets/clients/ibm.png" },
  { name: "Wipro",            src: "/assets/clients/wipro.png" },
  { name: "Knowledgewoods",   src: "/assets/clients/knowledgewoods.png" },
  { name: "EIFS",             src: null },
  { name: "Booming Bulls",    src: "/assets/clients/booming-bulls.png" },
  { name: "Response Fabrics", src: "/assets/clients/response-fabrics.png" },
  { name: "DSIM",             src: "/assets/clients/dsim.png" },
  { name: "Aman Travels",     src: "/assets/clients/aman-travels.png" },
  { name: "Cemex UK",         src: "/assets/clients/cemex.png" },
  { name: "AT&T US",          src: "/assets/clients/att.png" },
];

export default function ClientMarquee({
  eyebrow = "Trusted by industry leaders",
  title = "Clients we've worked with.",
  testId = "client-marquee",
  className = "",
}) {
  const tiles = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section className={`relative py-20 md:py-24 border-t border-white/5 overflow-hidden ${className}`} data-testid={`${testId}-section`}>
      <style>{`
        @keyframes bc-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .bc-marquee-track { animation: bc-marquee 34s linear infinite; will-change: transform; }
        .bc-marquee:hover .bc-marquee-track { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) { .bc-marquee-track { animation: none; } }
      `}</style>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-10 md:mb-12">
        <Reveal>
          <div className="eyebrow mb-4">{eyebrow}</div>
          <h2 className="font-serif-display text-3xl md:text-5xl leading-[1.05]">{title}</h2>
        </Reveal>
      </div>

      <div className="relative bc-marquee">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 md:w-28 z-10 bg-gradient-to-r from-[#050505] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 md:w-28 z-10 bg-gradient-to-l from-[#050505] to-transparent" />
        <div className="bc-marquee-track flex gap-4 w-max px-2" data-testid={testId}>
          {tiles.map((c, i) => (
            <div
              key={`${c.name}-${i}`}
              className="group w-44 md:w-52 h-24 md:h-28 flex items-center justify-center bg-white/[0.97] border border-white/10 px-4 flex-shrink-0 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 transition-[filter,opacity]"
              style={{ borderRadius: 0 }}
              data-testid={`${testId}-tile-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              {c.src ? (
                <img src={c.src} alt={c.name} loading="lazy" draggable={false} className="max-h-14 md:max-h-16 max-w-full object-contain" />
              ) : (
                <div className="text-center">
                  <div className="text-black font-bold text-sm md:text-base leading-tight" style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>{c.name}</div>
                  <div className="text-[9px] tracking-[0.22em] uppercase text-black/40 mt-1">Client</div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
